import { _ as __assign } from '../../chunks/bundle-C7jYHvwG.js';
import React__default from 'react';
import { G as GroupChannelHeaderView } from '../../chunks/bundle-BAQj91eb.js';
import { useGroupChannelContext } from '../context.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DUTyBaXr.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-CbEyAimK.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BR3O1lZq.js';
import '../../chunks/bundle-TGosz9cX.js';
import '../../chunks/bundle-DvcOxLrR.js';
import '../../chunks/bundle-DImSV9VW.js';
import '../../chunks/bundle-pOZPN8hk.js';
import '../../chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CDjVXDOc.js';
import '../../chunks/bundle-Dl9NVsui.js';
import '../../chunks/bundle-DkviGBGz.js';
import '../../chunks/bundle-DfDrbjM5.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-CIN9yQRB.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-Ci2fMtNJ.js';
import '../../ui/IconButton.js';
import '@sendbird/chat/message';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-gQ2a8Eki.js';
import '../../chunks/bundle-MyLy9AIu.js';
import 'react-dom';
import '../../ui/Button.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-CLonR-iH.js';
import '../../chunks/bundle-C6-Ix-Lk.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-MrMJJXf2.js';
import '../../chunks/bundle-ryUmMhVP.js';
import '../../chunks/bundle-C1U8wE49.js';
import '../../chunks/bundle-Dpdq7qeD.js';
import '../../chunks/bundle-90vsNbxW.js';
import '../../chunks/bundle-MkyS3j4-.js';
import '../../chunks/bundle-LPNnEgGp.js';

var GroupChannelHeader = function (props) {
    var context = useGroupChannelContext();
    return (React__default.createElement(GroupChannelHeaderView, __assign({}, props, context, { currentChannel: context.currentChannel })));
};

export { GroupChannelHeader, GroupChannelHeader as default };
//# sourceMappingURL=GroupChannelHeader.js.map
